import {useRouteMatch} from 'react-router-dom';

import Tooltip from '@/components/Tooltip';
import {feLogger, openHomePage} from '@/buried';
import {routerPublicPath, tocRouters} from '@/config/routers';
import Anchor from '@/components/Anchor';

import styles from './index.module.scss';
import classNames from 'classnames';
import logoNew from '@/assets/img/logoNew.png';
import logoRepository from '@/assets/img/logoRepository.png';
import logoFind from '@/assets/img/logoFind.png';

const homeUrl = new URL(routerPublicPath, window.location.origin).toString();

interface IProps {
    showTitle?: boolean;
    disableTips?: boolean;
}

const Logo: React.FC<IProps> = () => {
    const isHome = !!useRouteMatch({path: tocRouters.Welcome.path, exact: true});

    function handleClickLogo(event?: React.MouseEvent<Element, MouseEvent>) {
        event?.preventDefault();
        // feLogger(openHomePage);
        // window.location.href = homeUrl;
    }

    const imgSrc = isHome ? logoRepository : logoFind;

    return (
        <div className={styles.wrap}>
            <div className={styles.logo} onClick={handleClickLogo}>
                {isHome
                    ? <img src={imgSrc} className={classNames(styles.logoNew)} />
                    : (
                        // <Tooltip className={styles.tooltip} placement={'bottom'} content={'返回首页'}>
                        <img src={logoNew} className={styles.icon} />
                        // </Tooltip>
                    )}
            </div>
        </div>
    );
};

export default Logo;
